import React, { useState } from 'react';
import cn from 'classnames';
import ReactSelect from 'react-select';
import { useController, Control, FieldValues } from 'react-hook-form';
import './index.scss';

interface SelectProps {
	label?: string;
	labelClass?: string;
	className?: string;
	name: string;
	disabled?: boolean;
	control: Control<FieldValues | any>;
	defaultValue?: any;
	placeholder?: string;
	options: Array<{ value: boolean | string | number; label: string } | string>;
}

export const SelectControlled = ({
	label,
	name,
	className,
	options,
	control,
	defaultValue,
	disabled = false,
	placeholder,
	labelClass,
	...rest
}: SelectProps) => {
	const { field, fieldState } = useController({
		control,
		name,
		defaultValue: defaultValue?.value,
	});
	const [value, setValue] = useState(defaultValue || '');

	/* const customStyles = {
		option: (provided, state) => ({ 
			...provided,
			backgroundColor: state.isSelected ? '#ED5939' : 'white'
		})
	} */

	return (
		<div className={className}>
			{label && (
				<label
					htmlFor={name}
					className={`label ${labelClass}`}
				>
					{label}
				</label>
			)}
			<ReactSelect
				isDisabled={disabled}
				// styles={customStyles}
				className={cn('select', {
					'outline outline-2 outline-red': fieldState.error,
				})}
				options={options}
				{...field}
				{...rest}
				theme={(theme) => ({
					...theme,
					colors: {
						...theme.colors,
						primary: '#ED5939',
						primary25: '#F4F4F4',
					},
				})}
				placeholder={placeholder}
				value={value}
				onChange={(e) => {
					setValue(e);
					field.onChange(e.value);
				}}
			/>
			{fieldState.error && (
				<div className='mt-2 text-red text-xs normal-case capitalize'>
					{fieldState.error.message}
				</div>
			)}
		</div>
	);
};
